import DashboardLayout from "@/components/DashboardLayout";
import OpportunitiesPage from "@/pages/OpportunitiesPage";

/**
 * In-dashboard wrapper for the public opportunities listing.
 * Preserves the student's dashboard chrome (sidebar, bottom-nav) so clicking
 * «استكشف الفرص» never dumps the user out to the public marketing page.
 */
export default function DashboardBrowseOpportunities() {
  return (
    <DashboardLayout>
      <OpportunitiesPage embedded />
    </DashboardLayout>
  );
}
